import * as actions from "./actions";
import { ActionType, getType } from "typesafe-actions";
import { combineReducers } from "redux";

import { BookRecurringOrder } from "./model/BookRecurringOrder";
import { BookRecurringState } from "./model/BookRecurringState";

export type BookRecurringAction = ActionType<typeof actions>;

const initialOrder: BookRecurringOrder = {
  startDate: "",
  endDate: "",
  startAddress: {},
  endAddress: {},
  startWindow: [7, 17],
  endWindow: [7, 17],
  days: [],
  extras: []
};

export default combineReducers<BookRecurringState, BookRecurringAction>({
  order: (state = initialOrder, action) => {
    switch (action.type) {
      case getType(actions.updateOrder): {
        return {
          ...action.payload
        };
      }
      case getType(actions.resetOrder): {
        return { ...initialOrder };
      }
      default:
        return state;
    }
  }
});
